import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "22 17 13.5 8.5 8.5 13.5 2 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "16 17 22 17 22 11", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "TrendingDown";
const TrendingDown = memo(themed(Icon));
export {
  TrendingDown
};
//# sourceMappingURL=trending-down.js.map
